import type { InvoiceRepository } from '../application/InvoiceRepository'

/** Repli fixtures en lecture seule; les commandes remontent toujours l'erreur. */
export function createResilientInvoiceRepository(
  primary: InvoiceRepository,
  fallback: InvoiceRepository,
): InvoiceRepository {
  return {
    async list(filters) {
      try {
        return await primary.list(filters)
      } catch (error) {
        console.error('Factures indisponibles, repli fixtures.', error)
        return fallback.list(filters)
      }
    },
    async getByReference(reference) {
      try {
        return await primary.getByReference(reference)
      } catch (error) {
        console.error('Facture indisponible, repli fixtures.', error)
        return fallback.getByReference(reference)
      }
    },
    issue(command) {
      return primary.issue(command)
    },
    cancel(command) {
      return primary.cancel(command)
    },
    listPayments(invoiceId) {
      return primary.listPayments(invoiceId)
    },
    async listRecentPayments(filters) {
      try {
        return await primary.listRecentPayments(filters)
      } catch (error) {
        console.error('Paiements indisponibles, repli fixtures.', error)
        return fallback.listRecentPayments(filters)
      }
    },
    searchOpenInvoices(term) {
      // Choisir une facture à encaisser exige la vraie liste : une suggestion
      // issue de fixtures ferait viser le mauvais dossier.
      return primary.searchOpenInvoices(term)
    },
    recordPayment(command) {
      return primary.recordPayment(command)
    },
    cancelPayment(command) {
      return primary.cancelPayment(command)
    },
    getClientCreditAccount(clientId) {
      return primary.getClientCreditAccount(clientId)
    },
    applyClientCredit(command) {
      return primary.applyClientCredit(command)
    },
    listItems(invoiceId) {
      return primary.listItems(invoiceId)
    },
    sendCreditNote(command) {
      return primary.sendCreditNote(command)
    },
    sendReceipt(command) {
      return primary.sendReceipt(command)
    },
    listCreditNotes(invoiceId) {
      return primary.listCreditNotes(invoiceId)
    },
    createCreditNote(command) {
      return primary.createCreditNote(command)
    },
    transitionCreditNote(command) {
      return primary.transitionCreditNote(command)
    },
    replaceItems(command) {
      return primary.replaceItems(command)
    },
    send(command) {
      return primary.send(command)
    },
    async getBillingKpis() {
      try {
        return await primary.getBillingKpis()
      } catch (error) {
        console.error('KPI de facturation indisponibles, repli fixtures.', error)
        return fallback.getBillingKpis()
      }
    },
    async listPaymentsForClient(clientId, limit) {
      try {
        return await primary.listPaymentsForClient(clientId, limit)
      } catch (error) {
        console.error('Paiements du client indisponibles, repli fixtures.', error)
        return fallback.listPaymentsForClient(clientId, limit)
      }
    },
  }
}
